<template>
  <modal-padrao
    ref="modal-formula-derivada"
    max-width="90%"
    persistente
    :titulo-ok="$t('geral.botoes.salvar')"
    :titulo-cancelar="$t('geral.botoes.voltar')"
    :mostra-botao-salvar="!visualizar"
    @ok="confirmacaoSalvar"
  >
    <template v-slot:titulo>
      <div class="d-flex align-center">
        <span>{{ $t('modulos.formula.modal_formula_derivada.titulo') }}</span>
      </div>
    </template>
    <v-chip v-if="form.id" small>
      {{ $t('modulos.formula.formulario.codigoTag') + `${form.codigo}` }}
    </v-chip>
    <div class="mt-3">
      <v-form ref="form" class="row">
        <input-text
          v-model="form.simbolo"
          class="col-12 col-md-2"
          :label="$t('modulos.formula.formulario.simbolo')"
          :regras-personalizadas="[regraSimbolo]"
          obrigatorio
          :min="1"
          :max="15"
          :disabled="visualizar"
        />
        <input-text
          v-model="form.nome"
          class="col-12 col-md-5"
          :label="$t('modulos.formula.formulario.nome')"
          :min="1"
          :max="500"
          obrigatorio
          trim
          :disabled="visualizar"
        />
        <input-text
          v-model="form.descricao"
          class="col-12 col-md-5"
          :label="$t('modulos.formula.formulario.descricao')"
          :min="0"
          :max="1000"
          :disabled="visualizar"
        />
        <input-unidade-medida
          v-model="form.unidadeMedidaId"
          class="col-12 col-md-3"
          :label="$t('modulos.formula.formulario.unidadeMedida')"
          :multiplos="false"
          obrigatorio
          :disabled="visualizar"
        />
        <input-radio
          v-model="form.flagRequerComponentesIncerteza"
          class="col-12 col-md-3"
          :divider="false"
          :options="opcoes.booleano"
          :label="flagRequerEhObrigatorio"
          :disabled="visualizar"
        />
        <input-radio
          v-model="form.flagDisponivelEmCriteriosAceitacao"
          class="col-12 col-md-2"
          :divider="false"
          :options="opcoes.booleano"
          :label="
            $t('modulos.formula.formulario.disponivel_criterio_aceitacao')
          "
          :disabled="visualizar"
        />
        <input-file
          ref="inputFile"
          :value="form.fileImagem"
          accept="image/png"
          visualizador
          class="col-12 col-md-4"
          returns="base64"
          :placeholder="$t('geral.inputs.selecione')"
          :label="$t('modulos.formula.formulario.imagem')"
          :regras-personalizadas="[regraArquivo]"
          :disabled="visualizar"
          @clear="desvincularImagem"
          @nome-imagem="nomeImagem"
          @handle-upload="handlerUpload"
        />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="col-12"
              v-bind="attrs"
              v-on="!formMensurando.id ? on : null"
            >
              <input-ide
                ref="formula"
                v-model="form.formulaTexto"
                :formula-mensurando-id="formMensurando.id"
                :label="$t('modulos.formula.formulario.formula')"
                :obrigatorio="!!formMensurando.id"
                :disabled="!formMensurando.id || visualizar"
                :revisao-id="revisaoId"
              />
            </div>
          </template>
          <span>
            {{ $t('modulos.formula.tooltip_formula') }}
          </span>
        </v-tooltip>
      </v-form>
    </div>
  </modal-padrao>
</template>
<script>
import helpers from '@common/utils/helpers';
import { InputUnidadeMedida } from '@components/inputs';
import InputFile from '@components/inputs/InputFile.vue';
import FormulaService from '@common/services/cadastros/FormulaService.js';
import { FormulaModel } from '@common/models/cadastros/FormulaModel.js';

export default {
  components: {
    InputUnidadeMedida,
    InputFile,
  },
  props: {
    formMensurando: { type: Object, required: true },
    unidadeMedidaId: { type: Object, default: () => {} },
    revisaoFormulaDerivadaId: { type: String, default: '' },
  },
  data() {
    return {
      form: new FormulaModel({}),
      visualizar: false,
      tabelaValida: false,
      formulaValida: false,
      valido: false,
      opcoes: {
        booleano: helpers.BoleanoEnum,
      },
      revisaoId: null,
      error: {
        formulaMensurando: {
          status: false,
          message: '',
        },
      },
      dados: [],
      tabela: {
        dados: [],
        colunas: [
          {
            value: 'simbolo',
            text: this.$t(
              'modulos.formula.formulario.variaveis.tabela.simbolo'
            ),
            sortable: false,
            width: '120px',
          },
          {
            value: 'unidadeMedidaId',
            text: this.$t(
              'modulos.formula.formulario.variaveis.tabela.unidadeMedida'
            ),
            width: '230px',
            sortable: false,
          },
          {
            value: 'Formula',
            text: this.$t(
              'modulos.formula.formulario.variaveis.tabela.formulaCorrecao'
            ),
            width: '230px',
            sortable: false,
          },
          {
            value: 'descricao',
            text: this.$t(
              'modulos.formula.formulario.variaveis.tabela.descricao'
            ),
            sortable: false,
          },
        ],
      },
    };
  },
  computed: {
    flagRequerEhObrigatorio() {
      return this.$t(
        'modulos.formula.formulario.componentes_incerteza_obrigatorio'
      );
    },
  },
  watch: {
    form() {
      if (!this.formMensurando.revisoes.length) {
        this.revisaoId = this.revisaoFormulaDerivadaId;
      } else {
        this.revisaoId = this.formMensurando.revisoes.filter(
          (el) => el.numeroRevisao == this.formMensurando.numeroRevisao
        )[0]?.id;
      }
    },
    'form.formula'() {
      this.formulaValida = false;
    },
    'tabela.dados'() {
      this.form.variaveis = this.tabela.dados;
    },
  },
  methods: {
    regraSimbolo(v) {
      if (this.formMensurando.simbolo === v)
        return this.$t(
          'modulos.formula.validacoes.simbolo_diferente_mensurando'
        );

      return true;
    },
    handlerUpload(file) {
      this.form.imagem = file;
    },
    desvincularImagem() {
      this.form = {
        ...this.form,
        imagem: null,
        nomeArquivoImagem: null,
        fileImagem: null,
      };
    },
    nomeImagem(nomeImagem) {
      this.form.nomeArquivoImagem = nomeImagem ? nomeImagem : null;
    },
    regraArquivo(v) {
      if (!v) return true;
      if (v?.type == 'image/png') return true;
      return this.$t(`modulos.colaborador.validacoes.permitido_png`);
    },
    atualizarVariaveisInput(removerVariavel) {
      this.$refs['formula'].buscarVariaveis(removerVariavel);
    },
    async abrirModal(
      formulaDerivada = null,
      visualizar = false,
      formulaExistente = false
    ) {
      await this.limparForm();
      await this.$nextTick(() => {
        this.$refs['inputFile']?.clearAll();
      });
      if (this.unidadeMedidaId)
        this.form.unidadeMedidaId = this.unidadeMedidaId;

      if (formulaExistente) {
        this.form = {
          ...formulaDerivada,
          unidadeMedidaId: formulaDerivada.unidadeMedida,
        };
        if (this.form?.unidadeMedida?.id) {
          this.form.unidadeMedidaId = {
            text: this.form?.unidadeMedida?.nome,
            value: this.form?.unidadeMedida?.id,
          };
        }
      }
      this.visualizar = visualizar;
      this.$refs['modal-formula-derivada'].abrirModal();
    },
    fecharModal() {
      this.$refs['modal-formula-derivada'].fecharModal();
    },
    async confirmacaoSalvar() {
      if (this.id) await this.confirmarSalvar();

      await this.salvar();
    },
    salvar() {
      if (!this.$refs.form.validate()) return;
      const formUnidadeMedida = { ...this.form.unidadeMedidaId };
      this.$store.dispatch('Layout/iniciarCarregamento');
      FormulaService.salvarDerivada(this.formMensurando.id, this.form)
        .then(() => {
          this.toastSucesso(this.$t(`modulos.formula.cadastro_sucesso`));
          this.$emit('atualizar-dados');
          this.fecharModal();
        })
        .catch(() => {
          this.form.unidadeMedidaId = formUnidadeMedida;
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    limparForm: function () {
      this.desvincularImagem();
      this.form = new FormulaModel({});
    },
  },
};
</script>

<style lang="scss">
.v-dialog.v-dialog-right-position {
  border-radius: 8px 0px 0px 8px;
}

.v-dialog.v-dialog-center-position {
  border-radius: 8px;
}

.v-card__modal {
  .v-card__title {
    padding: 12px 12px !important;

    .v-btn {
      height: fit-content;
      padding: 3px !important;
    }

    font-size: 18px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0em;
    text-align: left;
  }

  .v-card__actions,
  .corpo-modal {
    padding: 0 12px;
    max-height: 70vh;
  }
}

.modal-padrao {
  .v-card__modal {
    display: flex;
    flex-direction: column;
  }
}

.modal-padrao .p-dropdown-items {
  height: 180px;
  position: fixed !important;
  overflow-y: auto !important;
}

.footer {
  padding-top: 12px;
  z-index: -1;
}
</style>
